<template>
    <button
      class="rounded focus:outline-none"
      :class="[
        background ? background : 'bg-primary-yellow',
        width,
        height,
        opacity ? opacity : null,
        p ? p : 'py-2 px-6 md:py-2 md:px-8',
        color ? color : 'text-charcoal',
        border ? border : null,
        borderColor ? borderColor : null,
        font ? font : 'text-base',
      ]"
      @click="onClick"
      :disabled="disableButton"
      :style="{ background: background, width : width, height: height }"
      :type="type"
    >
      <div class="loader" v-if="loading"></div>
      <p v-else class="font-semibold">{{ text }}</p>
    </button>
</template>
<script>
export default {
  props: [
    "background",
    "width",
    "text",
    "loading",
    "opacity",
    "p",
    "type",
    "color",
    "disabled",
    "border",
    "borderColor",
    "font",
    "height",
    "heigth"
  ],

  data() {
    return {
      // loading: false,
    };
  },
  computed: {
    disableButton() {
      if (this.disabled || this.loading) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style scoped>
button:disabled {
  background-color: #fcc210;
  /* cursor: not-allowed; */
  opacity: 0.7;
}
.loader,
.loader:after {
  border-radius: 50%;
  width: 25px;
  height: 25px;
  overflow: hidden;
}
.loader {
  overflow: hidden;
  margin: auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 3px solid rgba(255, 255, 255, 0.2);
  border-right: 3px solid rgba(255, 255, 255, 0.2);
  border-bottom: 3px solid rgba(255, 255, 255, 0.2);
  border-left: 3px solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
